<template>
  <vs-popup
    classContent="popup-example"
    title="Attendee Info"
    :active.sync="show"
  >
    <div v-if="ticket != null">
      <!-- Main content wrapper -->
      <div class="position-relative" style="height:calc(100vh - 200px)!important">
        <div class="content-wrapper" style="padding-bottom:20px">
          <h1>{{ ticket.ticket }}</h1>
          <!-- Base Info -->
          <div class="vx-row">
            <div class="vx-col w-full md:w-1/2 mb-base">
              <vs-input
                class="inputx"
                label="First Name"
                style="width:100%;"
                :danger="errors.firstName"
                :danger-text="errors.firstName"
                v-model="ticket.firstName"
                data-field="firstName"
              />
            </div>
            <div class="vx-col w-full md:w-1/2 mb-base">
              <vs-input
                class="inputx"
                label="Last Name"
                style="width:100%;"
                :danger="errors.lastName"
                :danger-text="errors.lastName"
                v-model="ticket.lastName"
                data-field="lastName"
              />
            </div>

            <div class="vx-col w-full md:w-1/2 mb-base">
              <vs-input
                class="inputx"
                label="Email"
                style="width:100%;"
                :danger="errors.email"
                :danger-text="errors.email"
                v-model="ticket.email"
                data-field="email"
              />
            </div>
            <div class="vx-col w-full md:w-1/2 mb-base">
              <vs-input
                class="inputx"
                label="Mobile"
                style="width:100%;"
                :danger="errors.phone"
                :danger-text="errors.phone"
                v-model="ticket.phone"
                data-field="phone"
              />
            </div>
          </div>

          <!-- Dynamic Fields -->
          <div class="vx-row my-5" v-for="(item, i) in fields" :key="i">
            <div class="vx-col w-full">
              <div class="mb-2">
                {{ item.field_q }}
                <span v-if="item.required" class="text-danger">*</span>
              </div>

              <!-- Text Input -->
              <template v-if="item.field_type === 'text'">
                <vs-input
                  class="inputx"
                  style="width:100%;"
                  :danger="fieldErrors[item.key]"
                  :danger-text="fieldErrors[item.key]"
                  v-model="item.field_a"
                  :data-field="'field_' + item.key"
                />
              </template>

              <!-- Email Input -->
              <template v-if="item.field_type === 'email'">
                <vs-input
                  type="email"
                  class="inputx"
                  style="width:100%;"
                  :danger="fieldErrors[item.key]"
                  :danger-text="fieldErrors[item.key]"
                  v-model="item.field_a"
                  @input="validateEmail(item)"
                  :data-field="'field_' + item.key"
                />
              </template>

              <!-- Mobile Input -->
              <template v-if="item.field_type === 'mobile'">
                <vs-input
                  class="inputx"
                  style="width:100%;"
                  :danger="fieldErrors[item.key]"
                  :danger-text="fieldErrors[item.key]"
                  v-model="item.field_a"
                  @input="validateMobile(item)"
                  onkeypress="return /^[-+0-9]/i.test(event.key)"
                  :data-field="'field_' + item.key"
                />
              </template>

              <!-- Textarea -->
              <template v-if="item.field_type === 'textarea'">
                <vs-textarea
                  style="width:100%;"
                  :danger="fieldErrors[item.key]"
                  :danger-text="fieldErrors[item.key]"
                  v-model="item.field_a"
                  :data-field="'field_' + item.key"
                />
              </template>

              <!-- Birthdate -->
              <template v-if="item.field_type === 'birthdate'">
                <vs-input
                  type="date"
                  class="inputx"
                  style="width:100%;"
                  :danger="fieldErrors[item.key]"
                  :danger-text="fieldErrors[item.key]"
                  v-model="item.field_a"
                  @input="validateBirthdate(item)"
                  :data-field="'field_' + item.key"
                />
              </template>

              <!-- Select -->
              <template v-if="item.field_type === 'select'">
                <select
                  class="form-control"
                  style="width:100%;"
                  v-model="item.field_a"
                >
                  <option
                    :key="index"
                    :value="choice"
                    :text="choice"
                    v-for="(choice, index) in item.options"
                  >
                    {{ choice }}
                  </option>
                </select>
                <span v-if="fieldErrors[item.key]" class="text-danger">
                  {{ fieldErrors[item.key] }}
                </span>
              </template>

              <!-- Radio with Other -->
              <template v-if="item.field_type === 'radio'">
                <ul class="leftx">
                  <li
                    class="modelx"
                    v-for="(choice, c) in item.options"
                    :key="c"
                  >
                    <vs-radio v-model="item.field_a" :vs-value="choice">{{
                      choice
                    }}</vs-radio>
                  </li>
                  <li class="modelx">
                    <vs-radio v-model="item.field_a" vs-value="other"
                      >Other</vs-radio
                    >
                    <vs-input
                      v-if="item.field_a === 'other'"
                      class="mt-2"
                      style="width:100%;"
                      placeholder="Please specify"
                      v-model="item.other_value"
                    />
                  </li>
                </ul>
              </template>

              <!-- Checkbox with Other -->
              <template v-if="item.field_type === 'checkbox'">
                <div class="my-2" v-for="(choice, c) in item.options" :key="c">
                  <vs-checkbox :vs-value="choice" v-model="item.field_a">
                    {{ choice }}
                  </vs-checkbox>
                </div>
                <div class="my-2">
                  <vs-checkbox vs-value="other" v-model="item.field_a">
                    Other
                  </vs-checkbox>
                  <vs-input
                    v-if="item.field_a.includes('other')"
                    class="mt-2"
                    style="width:100%;"
                    placeholder="Please specify"
                    v-model="item.other_value"
                  />
                </div>
              </template>

              <!-- Upload Image -->
              <template v-if="item.field_type === 'uploadimage'">
                <div class="upload-container">
                  <input
                    type="file"
                    :ref="'fileInput' + item.key"
                    @change="handleImageUpload($event, item)"
                    accept="image/*"
                    class="hidden"
                  />
                  <vs-button @click="triggerFileInput(item.key)">
                    Upload Image
                  </vs-button>
                  <div v-if="item.field_a" class="mt-2">
                    <img :src="item.field_a" class="preview-image" />
                    <vs-button
                      type="danger"
                      size="small"
                      @click="removeImage(item)"
                    >
                      Remove
                    </vs-button>
                  </div>
                  <div v-if="item.uploading" class="mt-2">
                    Uploading...
                  </div>
                  <span v-if="fieldErrors[item.key]" class="text-danger">
                    {{ fieldErrors[item.key] }}
                  </span>
                </div>
              </template>
            </div>
          </div>

          <!-- Order Remark -->
          <!-- <div class="vx-row">
            <div class="vx-col w-full mb-base">
              <label>Order Remark</label>
              <vs-textarea v-model="ticket.order.remark" />
            </div>
          </div> -->
          <vs-divider />
        </div>
        <div class="fixed-button-container d-flex justify-between items-center pt-3">
          <div class="pa-4">
            <span v-if="ticket.updated_at && ticket.updated_by">
              Updated by {{ ticket.updated_by.name }}
              <!-- at {{ ticket.updated_at }} -->
            </span>
          </div>
          <div class=" pr-4">
            <vs-button @click="submit">Save</vs-button>
          </div>
        </div>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import Service from "@/services";
import { countries } from "@/utils/Countries";
import { mapState } from "vuex";

export default {
  props: {
    showDialog: Boolean,
    attendee: Object
  },

  data: () => ({
    ticket: null,
    fields: [],
    countries: [],
    fieldErrors: {}
  }),
  computed: {
    ...mapState({
      s: state => {
        return state.Utility.s;
      },
      e: state => {
        return state.Utility.e;
      }
    }),
    show: {
      get() {
        if (this.showDialog) {
          this.initializeForm();
        } else {
          this.resetForm();
        }
        return this.showDialog;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      }
    }
  },

  methods: {
    initializeForm() {
      Service.Ticket.get(this.attendee.ticket,this.e, this.s).then(res => {
        this.ticket = res.data.ticket;
        this.fields = [];
        [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].forEach(key => {
          if (this.ticket.event["field_q" + key]) {
            let options = [];
            if (this.ticket.event["field_opt" + key]) {
              options = this.ticket.event["field_opt" + key].split(";");
            }

            let answer = this.initializeAnswer(
              this.ticket.event["field_type" + key],
              this.ticket["field_a" + key]
            );

            this.fields.push({
              key,
              field_q: this.ticket.event["field_q" + key],
              field_desc: this.ticket.event["field_desc" + key],
              field_type: this.ticket.event["field_type" + key],
              field_opt: this.ticket.event["field_opt" + key],
              field_a: answer,
              other_value: "",
              required: this.ticket.event["field_required" + key] || false,
              options
            });
          }
        });
        this.countries = Object.values(countries);
      });
    },

    initializeAnswer(fieldType, value) {
      if (fieldType === "checkbox") {
        return value ? value.split(",") : [];
      }
      return value || null;
    },

    resetForm() {
      this.fields = [];
      this.ticket = null;
      this.errors = {};
      this.fieldErrors = {};
    },

    validateEmail(item) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(item.field_a)) {
        this.fieldErrors[item.key] = "Please enter a valid email address";
      } else {
        this.fieldErrors[item.key] = null;
      }
      return !this.fieldErrors[item.key];
    },

    validateMobile(item) {
      const mobileRegex = /^[-+0-9]{10,15}$/;
      if (!mobileRegex.test(item.field_a)) {
        this.fieldErrors[item.key] = "Please enter a valid mobile number";
      } else {
        this.fieldErrors[item.key] = null;
      }
      return !this.fieldErrors[item.key];
    },

    validateTicketEmail(item) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(item)) {
        this.errors.email = "Please enter a valid email address";
        return false;
      } else {
        this.errors.email = null;
      }
      return true;
    },

    validateTicketMobile(item) {
      const mobileRegex = /^[-+0-9]{10,15}$/;
      if (!mobileRegex.test(item)) {
        this.errors.phone = "Please enter a valid mobile number";
        return false;
      } else {
        this.errors.phone = null;
      }
      return true;
    },

    validateBirthdate(item) {
      const date = new Date(item.field_a);
      const today = new Date();

      if (date > today) {
        this.fieldErrors[item.key] = "Birthdate cannot be in the future";
      } else {
        this.fieldErrors[item.key] = null;
      }
      return !this.fieldErrors[item.key];
    },

    async handleImageUpload(event, item) {
      const file = event.target.files[0];
      if (!file) return;

      // Validate file type
      if (!file.type.startsWith("image/")) {
        this.fieldErrors[item.key] = "Please upload an image file";
        return;
      }

      // Validate file size (5MB)
      if (file.size > 5 * 1024 * 1024) {
        this.fieldErrors[item.key] = "Image size should be less than 5MB";
        return;
      }

      try {
        // Set uploading state
        this.$set(item, "uploading", true);

        // Prepare form data
        const formData = new FormData();
        formData.append("image", file);
        formData.append("ticket", this.ticket.ticket);
        formData.append("e", this.ticket.event.slug); // Add event slug from ticket data

        // Upload image using Service
        const response = await Service.Ticket.uploadAnswer(
          this.ticket.ticket,
          item.key,
          formData
        );

        if (response.success && response.data.path) {
          item.field_a = response.data.path;
          this.fieldErrors[item.key] = null;
        } else {
          throw new Error("Upload failed");
        }
      } catch (error) {
        this.fieldErrors[item.key] =
          "Failed to upload image: " + (error.message || "Unknown error");
      } finally {
        // Clear uploading state
        this.$set(item, "uploading", false);

        // Reset file input
        const fileInput = this.$refs["fileInput" + item.key];
        if (fileInput && fileInput[0]) {
          fileInput[0].value = "";
        }
      }
    },

    async removeImage(item) {
      try {
        // Set uploading state
        this.$set(item, "uploading", true);

        // Prepare form data
        const formData = new FormData();
        formData.append("remove", true);
        formData.append("ticket", this.ticket.ticket);
        formData.append("e", this.ticket.event.slug);

        // Call remove API
        await Service.Ticket.uploadAnswer(
          this.ticket.ticket,
          item.key,
          formData
        );

        // Clear the image
        item.field_a = null;

        // Reset file input
        const fileInput = this.$refs["fileInput" + item.key];
        if (fileInput && fileInput[0]) {
          fileInput[0].value = "";
        }
      } catch (error) {
        this.fieldErrors[item.key] =
          "Failed to remove image: " + (error.message || "Unknown error");
      } finally {
        // Clear uploading state
        this.$set(item, "uploading", false);
      }
    },

    triggerFileInput(key) {
      const fileInput = this.$refs["fileInput" + key];
      if (fileInput && fileInput[0]) {
        fileInput[0].click();
      }
    },
    scrollToError(key = null) {
      setTimeout(() => {
        // Find the first element with an error
        let errorElement;

        if (key) {
          // If key is provided, find that specific error element
          errorElement = document.querySelector(`[data-field="${key}"]`);
        } else {
          // Check main form fields first
          const mainErrorSelectors = [
            "firstName",
            "lastName",
            "email",
            "phone"
          ].map(field => `[data-field="${field}"]`);
          errorElement = document.querySelector(mainErrorSelectors.join(","));

          // If no main field errors, check dynamic fields
          if (!errorElement) {
            errorElement = document.querySelector("[data-field].vs-danger");
          }
        }

        if (errorElement) {
          errorElement.scrollIntoView({
            behavior: "smooth",
            block: "center"
          });
          // Optional: add focus
          if (
            errorElement.tagName === "INPUT" ||
            errorElement.tagName === "TEXTAREA"
          ) {
            errorElement.focus();
          }
        }
      }, 100); // Small delay to ensure DOM is updated
    },

    validateForm() {
      let isValid = true;
      this.errors = {};
      this.fieldErrors = {};
      let firstErrorField = null;

      // Validate main fields first
      if (!this.ticket.firstName) {
        this.errors.firstName = "First name is required";
        firstErrorField = "firstName";
        isValid = false;
      }
      if (!this.ticket.lastName) {
        this.errors.lastName = "Last name is required";
        firstErrorField = firstErrorField || "lastName";
        isValid = false;
      }
      if (!this.validateTicketEmail(this.ticket.email)) {
        firstErrorField = firstErrorField || "email";
        isValid = false;
      }
      if (!this.validateTicketMobile(this.ticket.phone)) {
        firstErrorField = firstErrorField || "phone";
        isValid = false;
      }

      // Validate required fields
      this.fields.forEach(item => {
        if (item.required && !item.field_a) {
          this.fieldErrors[item.key] = "This field is required";
          firstErrorField = firstErrorField || `field_${item.key}`;
          isValid = false;
        }

        // Type-specific validation
        if (item.field_a) {
          switch (item.field_type) {
            case "email":
              if (!this.validateEmail(item)) {
                firstErrorField = firstErrorField || `field_${item.key}`;
                isValid = false;
              }
              break;
            case "mobile":
              if (!this.validateMobile(item)) {
                firstErrorField = firstErrorField || `field_${item.key}`;
                isValid = false;
              }
              break;
            case "birthdate":
              if (!this.validateBirthdate(item)) {
                firstErrorField = firstErrorField || `field_${item.key}`;
                isValid = false;
              }
              break;
          }
        }
      });

      if (!isValid) {
        this.scrollToError(firstErrorField);
      }

      return isValid;
    },

    async submit() {
      if (!this.validateForm()) {
        // this.$vs.notify({
        //   title: 'Error',
        //   text: 'Please check the form for errors',
        //   color: 'danger'
        // });
        return;
      }

      const data = {
        ticket: this.ticket.ticket,
        firstName: this.ticket.firstName,
        lastName: this.ticket.lastName,
        email: this.ticket.email,
        phone: this.ticket.phone,
        remark: this.ticket.order.remark,
        fields: this.fields.map(field => ({
          ...field,
          field_a: this.formatFieldValue(field)
        })),
        e: this.e,
        s: this.s,
      };

      try {
        this.$vs.loading();
        await Service.Ticket.update(data);
        this.$vs.loading.close();
        this.$emit("submit");
        this.$vs.notify({
          title: "Success",
          text: "Form submitted successfully",
          color: "success"
        });
      } catch (error) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Error",
          text: "Failed to submit form",
          color: "danger"
        });
      }
    },

    formatFieldValue(field) {
      if (field.field_type === "checkbox") {
        const values = [...field.field_a];
        if (values.includes("other")) {
          const otherIndex = values.indexOf("other");
          values[otherIndex] = field.other_value;
        }
        return values.join(",");
      }

      if (field.field_type === "radio" && field.field_a === "other") {
        return field.other_value;
      }

      return field.field_a;
    }
  }
};
</script>

<style scoped>
.form-container {
  position: relative;
  min-height: 100%;
  padding-bottom: 80px; /* Height of button container + padding */
}

.content-wrapper {
  /* position: relative; */
  height: 100%;
  overflow-y: auto;
}

.button-spacer {
  height: 60px; /* Match height of button container */
}

.fixed-button-container {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  z-index: 10;
}

.button-wrapper {
  padding: 16px 24px;
  display: flex;
  justify-content: flex-end;
  background: white;
}

.preview-image {
  max-width: 200px;
  max-height: 200px;
  margin-top: 8px;
}

.hidden {
  display: none;
}

/* Add these styles to the parent vs-popup if needed */
/* ::v-deep .vs-popup {
  overflow: hidden;
} */

/* ::v-deep .popup-example {
  display: flex;
  flex-direction: column;
  overflow: hidden;
} */
</style>
